<template>
  <div>
    <el-menu class="sidebar" :router="true">
      <el-menu-item index="/">
        <i class="el-icon-menu" />
        <span>Dashboard</span>
      </el-menu-item>
      <el-menu-item index="/waitlist">
        <i class="el-icon-star-on" />
        <span>Waitlist</span>
      </el-menu-item>
      <el-menu-item index="/users">
        <i class="el-icon-user-solid" />
        <span>Users</span>
      </el-menu-item>
      <el-menu-item index="/credit-history">
        <i class="el-icon-s-finance" />
        <span>Credit</span>
      </el-menu-item>
      <el-menu-item index="/pending">
        <i class="el-icon-time" />
        <span>Pending Verification</span>
      </el-menu-item>
      <el-menu-item index="/credit">
        <i class="el-icon-s-finance" />
        <span>Credit Applications</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 25rem;
  min-height: 100vh;
  padding: 20rem 0;
  box-shadow: none;
}
</style>
